import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const SyncScopesRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>SyncScopesRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(atlasRoutes.syncScopesView({ params: { syncScopeId: uuid } }).path)
        }
      />
    </div>
  );
};
